import {Assignee} from './Assignee';

export function getAssigneeId(assignee: Assignee): string {
    return assignee.pcc?.id
        ?? assignee.agency?.id
        ?? assignee.agent?.id
        ?? '';
}
